<template>
    <div>
        <base-header type="gradient-primary" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="card">
                <div class="card-header border-0">
                </div>
                <div class="table-responsive">
                    <vue-good-table
                            :columns="columns"
                            :rows=allLoans
                            :line-numbers="true"
                            :search-options="{
                        enabled: true,
                        }"
                            :sort-options="{
                        enabled: true,
                        initialSortBy: {field: 'application_date', type: 'desc'}}"
                            :pagination-options="{
                enabled: true,
                perPage: 5
                }"
                            styleClass="table table-striped table-no-bordered table-hover">
                        <template slot="table-row" slot-scope="props">
    <span v-if="props.column.field == 'action'">
            <base-button type="danger" size="sm" @click="viewSummary(props.row)">View Summary</base-button>
    </span>
                            <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>
                        </template>
                    </vue-good-table>
                </div>
            </div>
        </base-header>
    </div>
</template>

<script>
    export default {
        name: "allApplications",
        data() {
            return {
                columns: [
                    {
                        label: 'Loan Date',
                        field: 'application_date',
                        formatFn: this.formatDate,
                    },
                    {
                        label: 'Amount Borrowed',
                        field: 'loan_amount_figures',
                        formatFn: this.formatCost,
                    },
                    {
                        label: 'Loan Status',
                        field: 'loan_status',
                        formatFn: this.formatStatus,
                    },
                    {
                        label: 'Action',
                        field: 'action',
                    },
                ],
            }
        },
        created() {
            this.authorizedUser(this.authorizeAdminOnly);
            this.$store.dispatch('viewallLoans_function');
        },
        methods: {
            
            viewSummary(params) {
                this.$router.push({
                    path: 'loanSummary',
                    query: {
                        loanId: params.loan_application_public_id,
                    },
                });
            },
            formartDate(date) {
                return moment(date).format('Do MMMM  YYYY');
            },
            formatCost(amount) {
                const result = Number(amount).toLocaleString()
                if (result !== 0) {
                    return `Ksh. ${result}`;
                } else {
                    return '0';
                }
            },
            formatStatus(value){
                if (value === '15'){
                    return 'Pending';
                }else {
                    return value;
                }
            }
        },
    }
</script>

<style scoped>

</style>
